import React from 'react';
import { HiSun, HiMoon } from 'react-icons/hi2';
import { useTheme } from '@/context/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div
      onClick={toggleTheme}
      className='flex items-center gap-3 mb-5 cursor-pointer hover:opacity-80 transition-opacity'
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div
        className={`relative flex items-center w-16 h-8 rounded-full transition-all duration-300 ease-in-out shadow-md ${
          theme === 'light' ? 'bg-gray-200' : 'bg-gray-800'
        }`}
      >
        {/* Toggle Thumb */}
        <div
          className={`absolute w-6 h-6 rounded-full shadow-md transition-all duration-300 ease-in-out ${
            theme === 'light' ? 'bg-gray-800 right-1' : 'bg-white left-1'
          }`}
        />

        {/* Icon */}
        <div
          className={`absolute flex items-center justify-center ${
            theme === 'light' ? 'left-2' : 'right-2'
          }`}
        >
          {theme === 'light' ? (
            <HiSun className='w-4 h-4 text-gray-800' />
          ) : (
            <HiMoon className='w-4 h-4 text-white' />
          )}
        </div>
      </div>
      <span className='font-semibold '>
        {theme === 'light' ? 'Dark' : 'Light'} Theme
      </span>
    </div>
  );
};

export default ThemeToggle;
